import {useState} from "react";
import {WorksitesFiltersType} from "@feature/worksites/home/filters/types";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {WorksitesPin} from "@feature/worksites/home/types";
import {Query, QueryResult} from "@material-table/core";
import {WorksitesWithIdSchema} from "@feature/types";
import {orderingFromQuery} from "@utils/pagination";

export const useHomeWorksites = () => {

  // hooks
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [loading, setLoading] = useState(true);

  // utils
  const buildFiltersPayload = (filters: WorksitesFiltersType) => ({
    flg_include_deleted: filters.include_inactive,
    flg_only_test: filters.show_only_test,
    flg_only_terminated: filters.show_only_terminated,
    search: filters.search,
    cod_worksite_type: filters.type?.value,
    cod_worksite_status: filters.status?.value,
    cod_province: filters.province?.value,
    id_creator: filters.creator?.value,
    id_shared_with: filters.shared_with?.value,
    id_area_manager: filters.visibile_to_manager?.value,
    id_agent: !!filters.visibile_to_manager ? filters.visibile_to_agent?.value : undefined,
  })

  // handlers
  const _baseHandler = async <T>(promise: Promise<T>) => {
    setLoading(true);
    try {
      return await promise;
    }
    finally {
      setLoading(false);
    }
  }
  const fetchPins = (
    filters: WorksitesFiltersType,
    box: {rng_latitude: [number, number], rng_longitude: [number, number]},
  ) => {
    const promise = countryApiRequest!.post(
      "/worksites/home/pins",
      {filters: buildFiltersPayload(filters), bounding_box: box},
    ) as unknown as Promise<WorksitesPin[]>;
    return _baseHandler(promise);
  }
  const fetchWorksitesPage = async (
    filters: WorksitesFiltersType,
    query: Query<WorksitesWithIdSchema>,
  ): Promise<QueryResult<WorksitesWithIdSchema>> => {
    const page = query?.page || 0;
    const payload = {
      filters: buildFiltersPayload(filters),
      ordering: !!query && orderingFromQuery(query),
      page: page + 1,
      page_size: !!query ? query.pageSize : 5,
    }
    const promise = countryApiRequest!.post(
      "/worksites/home/paginated",
      payload,
    ) as unknown as Promise<{items: WorksitesWithIdSchema[], total: number}>;
    const {items, total} = await _baseHandler(promise);
    return {data: items, page, totalCount: total};
  }

  return {loading, fetchPins, fetchWorksitesPage};
}